import { createRouter, createWebHistory } from "vue-router";
import { guestGuard } from "./guards/guest";
import { canAccessQuizGuard } from "./guards/canAccessQuiz";
import { canVerifyInformationsGuard } from "./guards/canVerifyInformations";
import { authGuard } from "./guards/auth";
import { hasVerifiedHisInformationsGuard } from "./guards/hasVerfiedHisInformations";
import { hasAnsweredQuizGuard } from "./guards/hasAnsweredQuiz";
import { canSubscribeGuard } from "./guards/canSubscribe";
import { isSubscribedGuard } from "./guards/isSubscribed";

const routes = [
  // Login route
  {
    path: "/login",
    name: "login",
    component: require("./views/auth/login.vue").default,
    beforeEnter: guestGuard.beforeEnter,
  },
  // Forgot password routes
  {
    path: "/send-reset-password-request",
    component: require("./views/auth/sendResetPasswordRequest.vue").default,
    beforeEnter: guestGuard.beforeEnter
  },
  {
    path: "/reset-password/:token",
    component: require("./views/auth/resetPassword.vue").default,
    beforeEnter: guestGuard.beforeEnter
  },
  // Quiz video route
  {
    path: "/quiz-tutorial",
    name: "quiz-tutorial",
    component: require("./views/quizTutorial.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, canAccessQuizGuard.beforeEnter],
  },
  // Quiz route
  {
    path: "/quiz",
    component: require("./views/quiz/layout.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, canAccessQuizGuard.beforeEnter],
    children: [
      {
        path: "",
        name: "quiz",
        redirect: "/quiz/country"
      },
      {
        path: "country",
        name: "quiz.country",
        component: require("./views/quiz/country.vue").default
      },
      {
        path: "commute",
        name: "quiz.commute",
        component: require("./views/quiz/commute.vue").default
      },
      {
        path: "fly",
        name: "quiz.fly",
        component: require("./views/quiz/fly.vue").default
      },
      {
        path: "eat",
        name: "quiz.eat",
        component: require("./views/quiz/eat.vue").default
      },
      {
        path: "shop",
        name: "quiz.shop",
        component: require("./views/quiz/shop.vue").default
      },
      {
        path: "home",
        name: "quiz.home",
        component: require("./views/quiz/home.vue").default
      }
    ]
  },
  // Verify informations route
  {
    path: "/verify-informations",
    name: "verify-informations",
    component: require("./views/verify-informations.vue").default,
    beforeEnter: [authGuard.beforeEnter, canVerifyInformationsGuard.beforeEnter]
  },
  // Home route
  {
    path: "/",
    redirect: "/news-feed",
  },
  // Content routes
  {
    path: "/news-feed",
    name: "news-feed",
    component: require("./views/content/cluster/index.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter]
  },
  {
    path: "/favorites",
    name: "favorites",
    component: require("./views/content/cluster/favorite-clusters.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter]
  },
  {
    path: "/news-feed/:cluster/articles",
    name: "news-feed.show",
    component: require("./views/content/cluster/show.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter]
  },
  {
    path: "/articles/:article",
    name: "articles.show",
    component: require("./views/content/article/show.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter]
  },
  // Account route
  {
    path: "/account",
    name: "account",
    component: require("./views/account.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter]
  },
  // Achievements route
  {
    path: "/goals",
    name: "goals",
    component: require("./views/goals.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter]
  },
  // Subscription route
  {
    path: "/subscription",
    name: "subscription",
    component: require("./views/subscription.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter, canSubscribeGuard.beforeEnter]
  },
  // Billing route
  {
    path: "/billing",
    name: "billing",
    component: require("./views/billing.vue").default,
    beforeEnter: [authGuard.beforeEnter, hasVerifiedHisInformationsGuard.beforeEnter, hasAnsweredQuizGuard.beforeEnter, isSubscribedGuard.beforeEnter]
  }
];

export default createRouter({
  history: createWebHistory("app"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0 };
  }
});
